var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online_rate"},[_c('dec-block-title',[_vm._v("昨日在线率TOP5(%)")]),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }